<template>
  <div class="faqDrawerWrapper ">
      <div class="question flex"  :class="{'open': drawerOpen}" @click="toggleDrawer">
          <dynamicTemplate :template="`<div class='dynamic-question' >${faqItem.question}</div>`"/><font-awesome-icon :icon="['fal', drawerOpen ? 'minus': 'plus']"/></div>
      <transition name="slide-down" mode="in-out">
      <div class="answer" :class="{'open': drawerOpen}" v-if="drawerOpen" >
          <dynamicTemplate :template="`<div class='dynamic-answer' >${faqItem.answer}</div>`"/>
      </div>
      </transition>
  </div>
</template>

<script>
import dynamicTemplate from 'v-runtime-template';
import FaqVideo from '@/components/helpTopics/FaqVideo.vue';

export default {
    name: 'FaqDrawer',
    props: {
        faqItem: {
            type: Object,
            required: true,
        },
        openDrawerOverride: {
            required: false,
        },
    },
    components: {
        dynamicTemplate,
        FaqVideo,
    },
    data () {
        return {
            drawerOpen: false,
        };
    },
    methods: {
        toggleDrawer () {
            this.drawerOpen = !this.drawerOpen;
            if (this.drawerOpen) {
                this.$emit('setChosenFaqId', this.faqItem.id);
            }
        },
        openCloseOverride (open = false) {
            this.drawerOpen = open;
        },
    },
    computed: {
        drawerOpenClass () {
            return this.drawerOpen ? 'open' : '';
        },
        clientConfig () {
            return this.$store.state.clientConfig;
        },
        isWebsiteLevel2 () {
            return this.websiteLevel === 2;
        },
        websiteLevel () {
            return this.clientConfig.websiteLevel;
        },
        fundOrScheme () {
            return this.clientConfig.fundOrScheme;
        },
    },
    watch: {
        openDrawerOverride: {
            handler (newFaqId, oldFaqId) {
                if (newFaqId !== oldFaqId) {
                    if (newFaqId === this.faqItem.id) {
                        this.openCloseOverride(true);
                        return;
                    }
                    this.openCloseOverride(false);
                }
            },
            immediate: true,
        },
        drawerOpen: {
            handler (newValue) {
                if (newValue === true) {
                    // log that the faq was opened
                    this.$store.dispatch('analytics/sendAnalyticsBeacon', {
                        logType: 'faqOpened',
                        page: this.$route.fullPath,
                        info: this.faqItem.question,
                    });
                }
            },
        },

    },
};
</script>

<style lang="scss" scoped>
.faqDrawerWrapper{
    margin-bottom: .5rem;
    .question{
        justify-content: space-between;
        padding: 1rem;;
        background: white;
        border-radius: 6px;
        user-select: none;
        cursor: pointer;
        transition: all .6s ease-in-out;
        font-size: 1.2rem;
        align-items: center;;
        &.open{
            background: var(--primaryColour);
            color: var(--textOnPrimary);
            border-radius: 6px 6px 0 0;
        }
    }
    .answer{
        transition: all .6s ease-in-out;
        border: 2px solid white;

        &.open{
             border: 2px solid var(--primaryColour);
            border-radius: 0 0 6px 6px;
        }
    }
    .dynamic-answer{
        padding: 1rem;
        background: #fefefe;
        overflow: hidden;
            border-radius: 0 0 6px 6px;

    }
}
</style>
